import { Flex, Header, Icon } from '@procurify/ui'
import { useIntl } from 'react-intl'

import { CostSummary } from '@webapp/core/components/CostSummary'
import { Price } from '@webapp/core/components/Price'
import { type OrderItem } from '@webapp/models/OrderItem'
import messages from './messages'
import { OrderItemTooltipStyled } from './styles/OrderItemTooltipStyled'
import { Quantity } from '../Quantity'

export interface IOrderItemTooltipProps {
  item: OrderItem
}

export const OrderItemTooltip = ({ item }: IOrderItemTooltipProps) => {
  const intl = useIntl()

  return (
    <OrderItemTooltipStyled>
      {item.PO_line_num > 0 && (
        <Header as='h5' gutter>
          <Flex.Row spacing={0.5}>
            <Flex.Item>
              <Icon icon='order' />
            </Flex.Item>
            <Flex.Item>
              {intl.formatMessage(messages.itemLabel)} #{item.PO_line_num}
            </Flex.Item>
          </Flex.Row>
        </Header>
      )}

      <CostSummary>
        <CostSummary.Cost>
          <th>{intl.formatMessage(messages.skuLabel)}</th>
          <td>{item.sku}</td>

          <th>{intl.formatMessage(messages.quantityLabel)}</th>
          <td>
            <Quantity mdp quantity={item.quantity} /> {item.unit}
          </td>

          <th>{intl.formatMessage(messages.unitCostLabel)}</th>
          <td>
            <Price
              currency={item.currency.name}
              price={parseFloat(item.price)}
            />
          </td>
        </CostSummary.Cost>
        <CostSummary.Total>
          <th>{intl.formatMessage(messages.totalCostLabel)}</th>
          <td>
            <Price
              currency={item.currency.name}
              price={parseFloat(item.total_cost)}
            />
          </td>
        </CostSummary.Total>
      </CostSummary>
    </OrderItemTooltipStyled>
  )
}

OrderItemTooltip.displayName = 'OrderItemTooltip'
